
//---------------------------------------
// Custom Email validation
//---------------------------------------
(function () {
    'use strict';

    window.Parsley.addValidator('customEmail', {
      validateString: function(value) {
        return /^[\w-_.]+@[\w_-]+(?:.[\w]+){1,4}$/.test(value);
      },
      messages: {
        en: 'invalid email format',
        es: 'Formato de correo inválido',
        "es-cr": 'Formato de correo inválido'
      }
    });

    window.Parsley.addValidator('month', {
      validateNumber: function(value) {
        return 12 >= value;
      }
    })

    window.Parsley.addValidator('day', {
      validateNumber: function(value) {
        return 31 >= value;
      }
    })

    window.Parsley.addValidator('year', {
      validateNumber: function(value) {
        var year = (new Date).getFullYear();

        return year <= value;
      }
    })

    window.Parsley.addValidator('customBirthday', {
      validateString: function(value) {
        return /^\d{2}\/\d{2}\/\d{4}$/g.test(value);
      },
      messages: {
        en: 'invalid (mm/dd/yyyy)',
        es: 'invalido (mm/dd/yyyy)',
        "es-cr": 'invalido (mm/dd/yyyy)'
      }
    });

    window.Parsley.addValidator('noPeriods', {
      validateString: function(value) {
        return /^[\w\'\-\s]+$/g.test(value);
      },
      messages: {
        en: 'No special characters.',
        es: 'No hay caracteres especiales.',
        "es-cr": 'No hay caracteres especiales.'
      }
    });

    window.Parsley.addValidator('mustHaveSpace', {
      validateString: function(value) {
        return /\s/g.test(value);
      },
      messages: {
        en: 'Needs at least one space.',
        es: 'Necesita al menos un espacio.',
        "es-cr": 'Necesita al menos un espacio.'
      }
    });

}());
